import { Component, NgZone } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// Root component
import { PouchService } from './services/pouch-service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  rootPage;
  credentials: any;
  first = true;
  constructor(private route: ActivatedRoute, public alertCtrl: AlertController, public platform: Platform, public router: Router, public http: HttpClient, public db: PouchService) {
    platform.ready().then(() => {
      localStorage.setItem('organization', 'sarutech');
      //fix for old credential login
      if (localStorage.getItem('credentials') != null) {
        localStorage.setItem(this.db.appinfo?.product + '_credentials', localStorage.getItem('credentials'));
        localStorage.removeItem('credentials');
      }
      if (localStorage.getItem('user') != null) {
        localStorage.setItem(this.db.appinfo?.product + '_user', localStorage.getItem('user'));
        localStorage.removeItem('user');
      }
      this.db.getJSON('./assets/data/translations.json').subscribe((data) => {
        this.db.translations = data;
        // Extracting query parameters when the component is initialized
        this.route.queryParams.subscribe((params) => {
          if ((this.first || this.router.url.includes('SignupPage')) && localStorage.getItem('global') == null) {
            console.log('remain on signup page');
          } else {
            this.first = false;
            console.log('continue processing');
            this.process();
          }
        });
      });
      //end of old credential login fix

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //statusBar.styleDefault();
      //splashScreen.hide();
      //statusBar.hide();
    });
  }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.onlineCheck();
    });
  }

  onlineCheck() {
    this.http.get('https://sarutech.com/couchdblogin/auth/validate-username/xs2da2432252sda').subscribe(
      (data) => {
        this.db.online = true;
        this.db.getUserInfo();
        console.log('online');
      },
      (err) => {
        this.db.online = false;
        console.log('offline');
      }
    );
  }

  process() {
    // Check for local credentials first
    let localCredentials = localStorage.getItem(`${this.db.appinfo?.product}_credentials`);
    if (localCredentials) {
      this.useCredentials(localCredentials);
      return;
    }

    // If no local credentials, check for global credentials
    let globalKey = localStorage.getItem('global');
    let globalCredentials = globalKey ? localStorage.getItem(`${globalKey}_credentials`) : null;
    if (globalCredentials) {
      this.useGlobalCredentials(globalCredentials, globalKey);
      return;
    }

    // If neither local nor global credentials exist, navigate to the login page
    this.router.navigateByUrl('/LoginPage');
  }

  useCredentials(credentials) {
    this.credentials = JSON.parse(credentials);
    if (this.db.online && this.credentials.userDBs && !this.credentials.userDBs[this.db.appinfo?.product]) {
      this.logout();
      return;
    }

    this.credentials.online = this.db.online; // Debug
    this.credentials.skip_setup = true; // Debug

    this.db.initDB(this.credentials).then(() => {
      this.db.get(this.credentials.user_id, 'setting').then((setting) => {
        if (!setting) {
          this.db.newSystemSetting(this.credentials).then(() => this.finish());
        } else if (setting.showtip === undefined) {
          this.logout();
        } else {
          this.finish();
        }
      });
    });
  }

  useGlobalCredentials(credentials, globalKey) {
    this.credentials = JSON.parse(credentials);
    this.credentials.online = this.db.online; // Debug
    this.credentials.skip_setup = true; // Debug

    localStorage.setItem(this.db.appinfo.base_product, globalKey);
    this.db.appinfo.product = globalKey;
    this.db.appinfo.filtered = true;

    if (!this.credentials.userDBs || !this.credentials.userDBs[globalKey]) {
      this.logout();
      return;
    }

    this.db.initDB(this.credentials).then(() => {
      this.db.get(this.credentials.user_id, 'setting').then((setting) => {
        if (!setting) {
          this.db.newSystemSetting(this.credentials).then(() => this.finish());
        } else if (setting.showtip === undefined) {
          this.logout();
        } else {
          this.finish();
        }
      });
    });
  }

  logout() {
    localStorage.removeItem(`${this.db.appinfo?.product}_credentials`);
    localStorage.removeItem(`${this.db.appinfo?.product}_user`); // Logout user
    this.router.navigateByUrl('/LoginPage');
  }

  finish() {
    this.db.appinfo.username = this.credentials.user_id;
    this.db.appinfo.platform = JSON.stringify(this.platform.platforms());

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    if (localStorage.getItem(this.db.appinfo?.product + '_user') == null) {
      this.router.navigateByUrl('/LoginUserPage');
    } else {
      this.router.navigateByUrl('/PreloadPage');
    }
  }
}
@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
